/**
 * The dashboard's chart colours, in one place so no tile picks its own. One hue (steel blue) does
 * all the data work; grey is the de-emphasis step. The template's per-card rainbow (#3872FA /
 * #10b981 / #7928ca) encoded nothing, so it is gone. Validated with the dataviz skill's
 * `validate_palette.js --ordinal` against the white card surface: STEEL over STEEL_LIGHT passes
 * (monotone lightness, single hue, light end 2.11:1).
 */
export const STEEL = "#2a78d6";
export const STEEL_LIGHT = "#86b6ef";
/** Past buckets on a sparkline — the current bucket alone takes STEEL. */
export const DEEMPHASIS = "#d6dae1";
/** Cancelled orders: a real stage, but not one that moves the pipeline forward. */
export const INERT = "#b8bfc9";

const COMPACT_MONEY = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", notation: "compact", maximumFractionDigits: 1 });

/**
 * Axis ticks only (₹1.2L, ₹3Cr). Display formatting of a figure the API already computed — the
 * exact value is always in the tooltip, the tile headline and the sales report, never only here.
 */
export function compactMoney(value: number): string {
  return COMPACT_MONEY.format(value);
}

const DAY = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });

/** "14 Sept" from the API's `yyyy-mm-dd` bucket start — UTC, so a bucket never shifts a day. */
export function bucketDay(periodStart: string): string {
  return DAY.format(new Date(periodStart));
}
